import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { rejectDocumentRequest, rejectDocumentResponse, rejectDocumentFailure } from '../actions/approve-documents.actions';
import { IRejectDocumentRequest, IRejectDocumentsResponse } from '../models/approve-document.model';

export const rejectDocumentFeatureKey = 'rejectDocument';

export interface RejectDocumentsState {
  rejectDocumentsRequest: IRejectDocumentRequest;
  rejectDocumentsSuccess: IRejectDocumentsResponse;
  rejectDocumentsFailure: IGenericError<ErrorResponse>;
}

export const initialState: RejectDocumentsState = {
  rejectDocumentsRequest: undefined,
  rejectDocumentsSuccess: undefined,
  rejectDocumentsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(rejectDocumentRequest, (state, action) => ({
    ...state,
    approveDocumentsRequest: action.request
  })),
  on(rejectDocumentResponse, (state, action) => ({
    ...state,
    approveDocumentsSuccess: action.response
  })),
  on(rejectDocumentFailure, (state, action) => ({
    ...state,
    approveDocumentsFailure: action.error
  }))
);

export const getRejectDocumentsRequest = (state: RejectDocumentsState) => state.rejectDocumentsRequest;
export const getRejectDocumentsResponse = (state: RejectDocumentsState) => state.rejectDocumentsSuccess;
export const getRejectDocumentsFailure = (state: RejectDocumentsState) => state.rejectDocumentsFailure;
